import { createAction, props } from '@ngrx/store';
import { ProfileCompletionEvent, TabClickEvent } from '@planone/bau365/util-fair-data';

export const tabClicked = createAction('[User Profile Page] Tab option clicked', props<TabClickEvent>());
export const profileCompletion = createAction(
  '[User Profile Completion Page] Options changed',
  props<ProfileCompletionEvent>()
);
